// @need-translate
import {BadgeType} from '../graphql/generated/types';

/**
 * 뱃지 정보 연령 텍스트를 만들기 위해 사용 됩니다.
 */
export const BADGE_TYPE_ALT_TEXT_MAP: {[key in BadgeType]: string} = {
  // BM 뱃지
  [BadgeType.BadgeRealFreeStatic]: '연재 무료',
  [BadgeType.BadgeWaitFreeStatic]: '기다무',
  [BadgeType.Badge0HourWaitfreeStatic]: '영다무',
  [BadgeType.Badge1HourWaitfreeStatic]: '일다무',
  [BadgeType.Badge2HourWaitfreeStatic]: '이다무',
  [BadgeType.Badge3HourWaitfreeStatic]: '삼다무',
  [BadgeType.BadgeLock]: '연재예정편',
  [BadgeType.BadgeUnlock]: '연재예정편 열람가능',
  // 업데이트 뱃지
  [BadgeType.BadgeNewStatic]: '신작',
  [BadgeType.BadgeUpStatic]: '최신 회차 업데이트됨',
  // 연령 뱃지
  [BadgeType.BadgeAge15Static]: '15세 연령 제한',
  [BadgeType.BadgeAge19Static]: '19세 연령 제한',
  [BadgeType.BadgeAge19CensorshipStatic]: '19세 연령 제한',
  // 이벤트 뱃지
  [BadgeType.BadgeEventStatic]: '이벤트 진행 중',
  // 미지정
  [BadgeType.BadgeAge18Static]: '',
  [BadgeType.BadgeNovelStatic]: '',
  [BadgeType.Badge3HourWaitfree]: '',
};
